//ekyc

const EKYC_LOGIN_TITLE = "Please login to your account";
const EKYC_LOGIN_SUBTITLE = "Please enter your name & mobile number to proceed with registration";
const EKYC_COUPON_LOGIN_TITLE = "Login With Coupon Code";
const EKYC_COUPON_LOGIN_SUBTITLE = "Please enter your coupon code to login";
const EKYC_SET_PASSWORD_TITLE = "Set Password for Your Account";
const EKYC_LOGIN_WITH_PASSWORD="Enter Your Password To Login";
const EKYC_FORGOT_MOBILE_VERIFY="Enter Mobile Number to Reset Password"

const EKYC_VERIFY_OTP_TEXT = {
  title: "OTP Send to Mobile Number",
};

export { EKYC_LOGIN_TITLE, EKYC_LOGIN_SUBTITLE, EKYC_COUPON_LOGIN_TITLE, EKYC_COUPON_LOGIN_SUBTITLE, EKYC_SET_PASSWORD_TITLE, EKYC_VERIFY_OTP_TEXT,EKYC_LOGIN_WITH_PASSWORD,EKYC_FORGOT_MOBILE_VERIFY };
